import { chargerStocksTrace } from '../lib/tracabilite';
import { urlTrace } from '../lib/tracabilite';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Plus, Scale, Package, Calculator, Printer, Trash2, Download } from '../lib/icons';
import { toast } from 'sonner';
import { PrintDoc } from '../components/print/PrintDoc';
import { BadgeFacture } from '../components/facturation/BadgeFacture';
import {
  fetchVentes,
  fetchCuves,
  fetchProduitsFinis,
  fetchTiers,
  fetchFinances,
  enregistrerVente,
  DENSITE_HUILE,
  PRIX_VENTE_HUILE,
  DENOMINATIONS_HUILE,
  PAIEMENT_DIFFERE,
  litresVersKg,
} from '../lib/dataProvider';
import { fmt, PageTitle, StatBlock } from '../components/shared/badges';
import { couleurGain, FOND_FAVORABLE, FOND_DEFAVORABLE } from '../lib/couleurs';
import { ActionsAdmin } from '../components/shared/ActionsAdmin';
import { useAuth } from '../lib/auth';
import { caisseImposee } from '../lib/permissions';
import { adminModifierVente, adminSupprimerVente } from '../lib/dataProvider';

import { ContactQuickForm } from '../components/reception/ContactQuickForm';
import { ContactCombobox } from '../components/shared/ContactCombobox';
import { PeriodeFiltre, dansPeriode } from '../components/shared/PeriodeFiltre';
import { FactureLibreDialog } from '../components/ventes/FactureLibreDialog';
import { ConditionnementDialog } from '../components/stocks/ConditionnementDialog';
import { ajouterLigneLibreVente, UNITES_LIGNE } from '../lib/dataProvider';
import { FilePlus2 } from '../lib/icons';

const inputCls =
  'mt-1.5 h-11 w-full border border-slate-300 bg-slate-50 px-3 font-data text-sm text-slate-900 outline-none transition-colors duration-150 focus:border-slate-900 focus:bg-white';
const label = 'text-xs font-bold uppercase tracking-[0.1em] text-slate-500';
const th = 'px-3 py-2 text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500';

export default function Ventes() {
  const { user } = useAuth();
  const [ventes, setVentes] = useState([]);
  const [cuves, setCuves] = useState([]);
  const [formats, setFormats] = useState([]);
  const [clients, setClients] = useState([]);
  const [comptes, setComptes] = useState([]);
  const [bl, setBl] = useState(null);
  const [nouveauClient, setNouveauClient] = useState(false);
  const [factureDiverse, setFactureDiverse] = useState(false);
  const [ligneLibre, setLigneLibre] = useState(null);
  const aujourdhui = new Date().toISOString().slice(0, 10);
  const [du, setDu] = useState('');
  const [au, setAu] = useState('');
  const ventesVisibles = ventes.filter((v) => dansPeriode(v.date, du, au));

  const exportVentes = () => {
    const head = ['Réf', 'Date', 'Client', 'Dénomination', 'Format', 'Unités', 'Poids (kg)', 'Prix (TND/kg)', 'Emballages', 'Total (TND)', 'Règlement'];
    const body = ventesVisibles.map((v) =>
      [v.id, v.date, v.client, v.denomination ?? '', v.format, v.unites ?? '', v.kg, v.prixKg, v.emballages, v.total, v.paiement].join(';')
    );
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([`\ufeff${[head.join(';'), ...body].join('\n')}`], { type: 'text/csv;charset=utf-8;' }));
    a.download = du || au ? `ventes_${du || 'debut'}_${au || 'fin'}.csv` : 'ventes.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    toast.success(`Export CSV — ${ventesVisibles.length} vente(s)`);
  };

  const [f, setF] = useState({
    date: aujourdhui,
    tiersId: '',
    denomination: DENOMINATIONS_HUILE[0],
    format: 'vrac',
    unites: '',
    prixKg: String(PRIX_VENTE_HUILE),
    prixUnitaire: '',
    compteId: PAIEMENT_DIFFERE,
    uniteVrac: 'kg',
    prixLitre: '',
  });
  const [lotsTrace,setLotsTrace]=useState([]);
  const [choixLots,setChoixLots]=useState({});
  useEffect(()=>{setChoixLots({});if(f.format!=='vrac')chargerStocksTrace().then(d=>setLotsTrace(d.produits.find(p=>p.id===f.format)?.lots||[])).catch(()=>setLotsTrace([]));},[f.format]);
  const [lignesCuves, setLignesCuves] = useState([{ cuveId: '', kg: '' }]);
  const [bouteille, setBouteille] = useState(false);
  const enLitres = f.format === 'vrac' && f.uniteVrac === 'L';

  const load = useCallback(() => {
    fetchVentes().then(setVentes);
    fetchCuves().then(setCuves);
    fetchProduitsFinis().then(setFormats);
  }, []);

  useEffect(() => {
    load();
    fetchTiers().then(setClients);
    fetchFinances().then((fin) => setComptes(fin.comptes));
  }, [load]);

  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const vrac = f.format === 'vrac';
  const formatSel = formats.find((x) => x.id === f.format);

  const majLigne = (i, k, v) => setLignesCuves((l) => l.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const ajouterLigne = () => setLignesCuves((l) => [...l, { cuveId: '', kg: '' }]);
  const retirerLigne = (i) => setLignesCuves((l) => (l.length === 1 ? l : l.filter((_, j) => j !== i)));

  const calc = useMemo(() => {
    if (vrac) {
      const q = Number(lignesCuves.reduce((s, l) => s + (Number(l.kg) || 0), 0).toFixed(3));
      if (enLitres) {
        const kg = litresVersKg(q);
        const huile = Number((q * (Number(f.prixLitre) || 0)).toFixed(3));
        return { litres: q, kg, emballages: 0, huile, total: huile };
      }
      const kg = q;
      const huile = Number((kg * (Number(f.prixKg) || 0)).toFixed(3));
      return { litres: 0, kg, emballages: 0, huile, total: huile };
    }
    const n = Number(f.unites) || 0;
    const litres = Number((n * (formatSel?.litres ?? 0)).toFixed(3));
    const kg = litresVersKg(litres);
    const pu = Number(f.prixUnitaire) || 0;
    const total = Number((n * pu).toFixed(3));
    return { litres, kg, emballages: 0, huile: total, total, pu };
  }, [f, vrac, enLitres, formatSel, lignesCuves]);

  const totaux = useMemo(
    () => ({
      n: ventes.length,
      kg: ventes.reduce((s, v) => s + v.kg, 0),
      litres: ventes.reduce((s, v) => s + (v.litres || 0), 0),
      ca: ventes.reduce((s, v) => s + v.total, 0),
      detail: ventes.filter((v) => v.format !== 'vrac').length,
    }),
    [ventes]
  );

  const stockFinis = formats.reduce((s, x) => s + x.stock, 0);

  const submit = async (e) => {
    e.preventDefault();
    const client = clients.find((c) => c.id === f.tiersId);
    const { error, row } = await enregistrerVente({ ...f, client: client?.nom, lignesCuves, lotsTracabiliteChoisis:Object.entries(choixLots).filter(([,n])=>Number(n)>0).map(([id,n])=>({id,unites:Number(n)})) });
    if (error) return toast.error(error);
    toast.success(
      row.paiement === 'Différé'
        ? `Vente ${row.id} — ${fmt(row.kg, 3)} kg · ${fmt(row.total, 3)} TND portés au compte de ${row.client}`
        : `Vente ${row.id} — ${fmt(row.kg, 3)} kg · ${fmt(row.total, 3)} TND encaissés`
    );
    setF({ ...f, tiersId: '', unites: '' });
    setLignesCuves([{ cuveId: '', kg: '' }]);
    load();
  };

  const nomFormat = (id, v) => (id === 'vrac' ? (v?.uniteVrac === 'L' ? 'Détail au litre' : 'Vrac (kg)') : formats.find((x) => x.id === id)?.nom ?? '—');
  const skuSel = formats.find((x) => x.id === f.format);

  return (
    <div data-testid="ventes-page" className="space-y-6">
      <PageTitle
        emoji="🧾"
        titre="Ventes & Comptoir"
        sous="Vrac au kilo, détail au litre ou produits finis — mise en bouteille intégrée"
        action={
          <div className="flex flex-wrap gap-2">
          <button
            type="button"
            data-testid="ouvrir-mise-en-bouteille"
            onClick={() => setBouteille(true)}
            className="flex h-11 items-center gap-2 border-2 border-slate-900 px-4 font-heading text-sm font-bold text-slate-900 transition-colors duration-150 hover:bg-slate-900 hover:text-white sm:h-10"
          >
            <Package size={16} /> Mise en bouteille
          </button>
          <button
            type="button"
            data-testid="ouvrir-facture-diverse"
            onClick={() => setFactureDiverse(true)}
            className="flex h-11 items-center gap-2 bg-slate-900 px-4 font-heading text-sm font-bold text-white transition-colors duration-150 hover:bg-slate-700 sm:h-10"
          >
            <FilePlus2 size={16} /> Créer une facture diverse
          </button>
          </div>
        }
      />
      {bouteille && <ConditionnementDialog cuves={cuves} onClose={() => setBouteille(false)} onDone={load} />}

      <div data-testid="regle-conversion" className="flex items-start gap-3 border border-slate-900 bg-slate-900 px-4 py-3">
        <Calculator size={16} className="mt-0.5 flex-shrink-0 text-white" />
        <p className="text-xs text-slate-200">
          <span className="font-bold uppercase tracking-[0.06em] text-white">Deux circuits distincts</span> — le
          vrac se prélève directement sur une ou plusieurs cuves et se facture <strong className="text-white">exclusivement au kilogramme</strong>. La vente au
          détail décrémente uniquement le <strong className="text-white">stock de produits finis en rayon</strong> (SKU issus du
          conditionnement) sans toucher aux cuves (1 L = {DENSITE_HUILE} kg).
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-4">
        <StatBlock testid="stat-ventes" titre="Ventes enregistrées" accent="border-l-slate-900" items={[['Opérations', fmt(totaux.n)], ['Dont détail', fmt(totaux.detail)]]} />
        <StatBlock testid="stat-volumes" titre="Volumes sortis" accent="border-l-emerald-600" items={[['Poids (kg)', fmt(totaux.kg, 3)], ['Dont détail (L)', fmt(totaux.litres, 3)]]} />
        <StatBlock testid="stat-produits-finis" titre="Produits finis en rayon" accent="border-l-sky-600" items={[['Unités', fmt(stockFinis)], ['Références (SKU)', fmt(formats.length)]]} />
        <StatBlock testid="stat-ca" titre="Chiffre d'affaires" accent="border-l-amber-600" items={[['Total (TND)', fmt(totaux.ca, 3)]]} />
      </div>

      <section data-testid="section-vente" className="border border-slate-200 bg-white">
        <div className="border-b border-slate-200 px-4 py-3">
          <h2 className="font-heading text-base font-bold tracking-tight text-slate-900">Nouvelle vente comptoir</h2>
          <p className="text-xs text-slate-500">Vrac : cumul de plusieurs cuves · Détail : stock de produits finis</p>
        </div>

        <form onSubmit={submit} className="space-y-5 px-4 py-4">
          {f.format!=='vrac'&&<details className="border border-emerald-200 p-3"><summary className="cursor-pointer text-sm">Lots de bouteilles : plus anciens en premier (FIFO), sauf sélection ci-dessous</summary><p className="text-xs mt-2">Prélevez physiquement les lots indiqués. Pour un autre lot, saisissez les unités réellement remises ; leur total doit égaler la vente.</p>{lotsTrace.map(l=><label className="flex gap-2 items-center my-2 text-sm" key={l.id}><span>{l.id} · {l.date} · {l.unites} disponibles</span><input aria-label={`Unités du lot ${l.id}`} type="number" min="0" max={l.unites} step="1" value={choixLots[l.id]||''} onChange={e=>setChoixLots(p=>({...p,[l.id]:e.target.value}))} className="border p-1 w-20"/></label>)}</details>}
          <div>
            <p className={label}>Format de vente</p>
            <div className="mt-2 grid grid-cols-2 gap-px bg-slate-200 md:grid-cols-4 xl:grid-cols-7">
              <button
                type="button"
                data-testid="format-vrac"
                onClick={() => setF((p) => ({ ...p, format: 'vrac', uniteVrac: 'kg', unites: '' }))}
                className={`flex items-center justify-center gap-2 px-3 py-3 text-sm font-bold transition-colors duration-150 ${
                  vrac && !enLitres ? 'bg-slate-900 text-white' : 'bg-white text-slate-700 hover:bg-slate-50'
                }`}
              >
                <Scale size={15} /> Vrac (kg)
              </button>
              <button
                type="button"
                data-testid="format-vrac-litres"
                onClick={() => setF((p) => ({ ...p, format: 'vrac', uniteVrac: 'L', unites: '' }))}
                className={`flex items-center justify-center gap-2 px-3 py-3 text-sm font-bold transition-colors duration-150 ${
                  enLitres ? 'bg-slate-900 text-white' : 'bg-white text-slate-700 hover:bg-slate-50'
                }`}
              >
                <Scale size={15} /> Détail au litre
              </button>
              {formats.map((x) => {
                const active = f.format === x.id;
                return (
                  <button
                    key={x.id}
                    type="button"
                    data-testid={`format-${x.id}`}
                    onClick={() => setF((p) => ({ ...p, format: x.id, unites: '', prixUnitaire: String(x.prixVente ?? '') }))}
                    className={`px-3 py-3 text-left transition-colors duration-150 ${active ? 'bg-slate-900 text-white' : 'bg-white hover:bg-slate-50'}`}
                  >
                    <span className="flex items-center gap-1.5 text-sm font-semibold">
                      <Package size={14} /> {x.formatNom}
                    </span>
                    <span className={`block font-data text-[10px] ${active ? 'text-slate-400' : 'text-slate-400'}`}>{x.denomination}</span>
                    <span className={`font-data text-[11px] ${active ? 'text-slate-300' : 'text-slate-500'}`}>
                      {fmt(x.stock)} u. en rayon
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            <div>
              <label className={label}>Date</label>
              <input data-testid="vente-date" type="date" value={f.date} onChange={set('date')} className={inputCls} />
            </div>
            <div>
              <label className={label}>Client</label>
              <div className="mt-1.5 flex gap-2">
                <ContactCombobox
                  contacts={clients}
                  value={f.tiersId}
                  onChange={(id) => setF((p) => ({ ...p, tiersId: id }))}
                  testid="vente-client"
                  className="-mt-1.5 w-full"
                />
                <button
                  type="button"
                  data-testid="vente-nouveau-client"
                  onClick={() => setNouveauClient(true)}
                  className="flex h-11 w-11 flex-shrink-0 items-center justify-center border-2 border-slate-900 text-slate-900 transition-colors duration-150 hover:bg-slate-900 hover:text-white"
                  title="Créer un nouveau client"
                >
                  <Plus size={16} />
                </button>
              </div>
            </div>
            <div>
              <label className={label}>Dénomination de l'huile</label>
              <select
                data-testid="vente-denomination"
                value={vrac ? f.denomination : (skuSel?.denomination ?? f.denomination)}
                disabled={!vrac}
                onChange={set('denomination')}
                className={`${inputCls} disabled:bg-slate-100 disabled:text-slate-600`}
              >
                {DENOMINATIONS_HUILE.map((d) => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </select>
              {!vrac && (
                <p className="mt-1.5 font-data text-[11px] text-slate-500">Imposée par le produit fini choisi.</p>
              )}
            </div>
            {!vrac && (
              <div>
                <label className={label}>Nombre d'unités (produits finis)</label>
                <input data-testid="vente-quantite" type="number" step="1" min="0" value={f.unites} onChange={set('unites')} className={inputCls} />
                <p className="mt-1.5 font-data text-[11px] text-slate-500">
                  Disponible en rayon : {fmt(skuSel?.stock ?? 0)} × {skuSel?.nom ?? '—'}
                </p>
              </div>
            )}
            <div>
              <label className={label}>{vrac ? (enLitres ? 'Prix de vente (TND/litre)' : 'Prix huile (TND/kg)') : 'Prix de vente unitaire (TND/unité)'}</label>
              {vrac ? (
                enLitres ? (
                  <>
                    <input data-testid="vente-prix-litre" type="number" step="0.001" min="0" value={f.prixLitre} onChange={set('prixLitre')} className={inputCls} />
                    <p className="mt-1.5 font-data text-[11px] text-slate-500">1 L = {DENSITE_HUILE} kg — équivaut à {fmt((Number(f.prixLitre) || 0) / DENSITE_HUILE, 3)} TND/kg</p>
                  </>
                ) : (
                <input data-testid="vente-prix" type="number" step="0.001" value={f.prixKg} onChange={set('prixKg')} className={inputCls} />
                )
              ) : (
                <>
                  <input data-testid="vente-prix-unitaire" type="number" step="0.001" min="0" value={f.prixUnitaire} onChange={set('prixUnitaire')} className={inputCls} />
                  <p className="mt-1.5 font-data text-[11px] text-slate-500">
                    Tarif de la référence : {fmt(skuSel?.prixVente ?? 0, 3)} TND — coût {fmt(skuSel?.cout ?? 0, 3)} TND
                  </p>
                </>
              )}
            </div>
            <div>
              <label className={label}>Encaissement (facultatif)</label>
              <select data-testid="vente-compte" value={f.compteId} onChange={set('compteId')} className={inputCls}>
                <option value={PAIEMENT_DIFFERE}>Paiement différé / Créance client</option>
                {(caisseImposee(user?.role) ? comptes.filter((c) => c.id === caisseImposee(user?.role)) : comptes).map((c) => (
                  <option key={c.id} value={c.id}>{c.nom}</option>
                ))}
              </select>
              <p className="mt-1.5 font-data text-[11px] text-slate-500">
                {f.compteId === PAIEMENT_DIFFERE
                  ? 'Facture émise, huile sortie du stock — le total s’ajoute au solde dû du client.'
                  : 'Encaissement immédiat dans la caisse ou la banque choisie.'}
              </p>
            </div>
          </div>

          {vrac && (
            <div data-testid="vrac-multi-cuves" className="border border-slate-200">
              <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-3 py-2">
                <p className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">
                  Cuves d'origine — cumul possible
                </p>
                <button
                  type="button"
                  data-testid="ajouter-cuve"
                  onClick={ajouterLigne}
                  className="flex h-9 items-center gap-1.5 border-2 border-slate-900 px-3 text-xs font-bold uppercase tracking-[0.06em] text-slate-900 transition-colors duration-150 hover:bg-slate-900 hover:text-white"
                >
                  <Plus size={14} /> Ajouter une cuve
                </button>
              </div>
              <div className="divide-y divide-slate-100">
                {lignesCuves.map((l, i) => {
                  const c = cuves.find((x) => x.id === l.cuveId);
                  return (
                    <div key={i} data-testid={`ligne-cuve-${i}`} className="flex flex-col gap-2 px-3 py-2 sm:flex-row sm:items-center">
                      <select
                        data-testid={`ligne-cuve-select-${i}`}
                        value={l.cuveId}
                        onChange={(e) => majLigne(i, 'cuveId', e.target.value)}
                        className="h-11 flex-1 border border-slate-300 bg-slate-50 px-3 font-data text-sm outline-none focus:border-slate-900 focus:bg-white"
                      >
                        <option value="">— Choisir la cuve —</option>
                        {cuves.map((x) => (
                          <option key={x.id} value={x.id}>{`${x.nom} · ${x.famille === 'lampante' ? 'LAMPANTE' : 'NOBLE'} · ${fmt(x.volume)} kg`}</option>
                        ))}
                      </select>
                      <input
                        data-testid={`ligne-cuve-kg-${i}`}
                        type="number"
                        step="0.1"
                        min="0"
                        placeholder={enLitres ? 'litres servis' : 'kg prélevés'}
                        value={l.kg}
                        onChange={(e) => majLigne(i, 'kg', e.target.value)}
                        className="h-11 w-full border border-slate-300 bg-slate-50 px-3 font-data text-sm outline-none focus:border-slate-900 focus:bg-white sm:w-40"
                      />
                      <span className="font-data text-[11px] text-slate-500 sm:w-40">
                        {c ? `reste ${fmt(c.volume - (enLitres ? litresVersKg(Number(l.kg) || 0) : Number(l.kg) || 0), 2)} kg · CMP ${fmt(c.cmp || 0, 3)} TND/kg` : ''}
                      </span>
                      <button
                        type="button"
                        data-testid={`retirer-cuve-${i}`}
                        onClick={() => retirerLigne(i)}
                        className="border border-slate-300 p-2 text-slate-600 transition-colors duration-150 hover:bg-red-600 hover:text-white"
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
              <p data-testid="vrac-total-kg" className="border-t border-slate-200 px-3 py-2 font-data text-xs text-slate-600">
                Total prélevé : {enLitres ? `${fmt(calc.litres, 3)} L soit ` : ''}{fmt(calc.kg, 3)} kg sur {lignesCuves.filter((l) => l.cuveId && Number(l.kg) > 0).length} cuve(s)
              </p>
              {calc.kg > 0 && (() => {
                const cout = lignesCuves.reduce((s, l) => {
                  const c = cuves.find((x) => x.id === l.cuveId);
                  const kg = enLitres ? litresVersKg(Number(l.kg) || 0) : Number(l.kg) || 0;
                  return s + kg * (c?.cmp || 0);
                }, 0);
                const cmpMoyen = cout / calc.kg;
                const prixKgVente = calc.huile / calc.kg;
                const marge = calc.huile - cout;
                return (
                  <div data-testid="vente-marge" className="mt-2 grid grid-cols-3 gap-px bg-slate-200 text-center">
                    <div className="bg-white px-2 py-2"><p className="text-[10px] uppercase tracking-[0.08em] text-slate-500">CMP (coût de revient)</p><p data-testid="vente-cmp" className="font-data text-sm font-bold text-slate-900">{fmt(cmpMoyen, 3)} TND/kg</p></div>
                    <div className="bg-white px-2 py-2"><p className="text-[10px] uppercase tracking-[0.08em] text-slate-500">Prix de vente</p><p className="font-data text-sm font-bold text-slate-900">{fmt(prixKgVente, 3)} TND/kg</p></div>
                    <div className={`px-2 py-2 ${marge >= 0 ? FOND_FAVORABLE : FOND_DEFAVORABLE}`}><p className="text-[10px] uppercase tracking-[0.08em] text-slate-500">Marge nette</p><p data-testid="vente-marge-valeur" className={`font-data text-sm font-bold ${couleurGain(marge)}`}>{marge >= 0 ? '+' : '−'}{fmt(Math.abs(marge), 3)} TND ({cmpMoyen > 0 ? `${fmt(((prixKgVente - cmpMoyen) / cmpMoyen) * 100, 1)} %` : '—'})</p></div>
                  </div>
                );
              })()}
              <p className="hidden">
              </p>
            </div>
          )}

          <div data-testid="vente-simulation" className="border border-slate-200">
            <p className="border-b border-slate-200 bg-slate-50 px-3 py-2 text-xs font-bold uppercase tracking-[0.1em] text-slate-500">
              Conversion & facturation
            </p>
            <dl className="grid grid-cols-2 gap-px bg-slate-200 md:grid-cols-5">
              {[
                ...(vrac ? [] : [['Volume (L)', `${fmt(calc.litres, 3)} L`]]),
                ['Poids (kg)', `${fmt(calc.kg, 3)} kg`],
                ...(vrac
                  ? [['Huile (TND)', fmt(calc.huile, 3)], ['Emballages (TND)', fmt(calc.emballages, 3)]]
                  : [['Prix unitaire (TND/u)', fmt(Number(f.prixUnitaire) || 0, 3)], ['Unités', fmt(Number(f.unites) || 0)]]),
                ['Total facture (TND)', fmt(calc.total, 3)],
              ].map(([k, v], i, arr) => (
                <div key={k} className={`bg-white px-3 py-2 ${i === arr.length - 1 ? 'md:bg-slate-900' : ''}`}>
                  <dt className={`text-[11px] ${i === arr.length - 1 ? 'md:text-slate-300' : 'text-slate-500'}`}>{k}</dt>
                  <dd
                    data-testid={k.startsWith('Poids') ? 'sim-kg' : k.startsWith('Total') ? 'sim-total' : undefined}
                    className={`tabular font-data text-sm font-semibold ${i === arr.length - 1 ? 'md:text-white' : 'text-slate-900'}`}
                  >
                    {v}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <button
            type="submit"
            data-testid="vente-submit"
            className="flex h-12 items-center justify-center gap-2 bg-slate-900 px-6 font-heading text-sm font-bold uppercase tracking-[0.06em] text-white transition-colors duration-150 hover:bg-slate-700"
          >
            <Plus size={16} /> Enregistrer la vente
          </button>
        </form>
      </section>

      <section data-testid="table-ventes-section" className="border border-slate-200 bg-white">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 px-4 py-3">
          <p className="font-heading text-base font-bold tracking-tight text-slate-900">
            Historique des ventes
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <PeriodeFiltre du={du} au={au} setDu={setDu} setAu={setAu} testid="periode-ventes" total={ventes.length} filtres={ventesVisibles.length} />
            <button
              type="button"
              data-testid="ventes-export-csv"
              onClick={exportVentes}
              className="flex h-10 items-center gap-2 border border-slate-300 px-3 text-sm font-semibold text-slate-800 transition-colors duration-150 hover:bg-slate-900 hover:text-white"
            >
              <Download size={15} /> Exporter CSV
            </button>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-left" data-testid="table-ventes">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50">
                {['Réf.', 'Date', 'Client', 'Dénomination', 'Format', 'Unités', 'Poids (kg)', 'Prix (TND/kg)', 'Emballages', 'Total (TND)', 'Règlement', 'Origine', ''].map((c) => (
                  <th key={c} className={th}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ventesVisibles.length === 0 ? (
                <tr data-testid="ventes-empty">
                  <td colSpan={13} className="px-3 py-10 text-center text-sm text-slate-500">Aucune vente sur cette période.</td>
                </tr>
              ) : (
                ventesVisibles.map((v) => (
                  <tr key={v.id} data-testid={`vente-row-${v.id}`} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="px-3 py-2 font-data text-sm font-semibold text-slate-900">
                      {v.id}
                      <BadgeFacture type="vente" id={v.id} />
                    </td>
                    <td className="px-3 py-2 font-data text-sm text-slate-700">{v.date}</td>
                    <td className="px-3 py-2 text-sm text-slate-800">{v.client}</td>
                    <td className="px-3 py-2 text-sm text-slate-700">{v.denomination ?? '—'}</td>
                    <td className="px-3 py-2 text-sm text-slate-700">{nomFormat(v.format, v)}</td>
                    <td className="tabular px-3 py-2 font-data text-sm text-slate-900">{v.unites ? fmt(v.unites) : '—'}</td>
                    <td className="tabular px-3 py-2 font-data text-sm font-semibold text-slate-900">{fmt(v.kg, 3)}</td>
                    <td className="tabular px-3 py-2 font-data text-sm text-slate-700">{fmt(v.prixKg, 3)}</td>
                    <td className="tabular px-3 py-2 font-data text-sm text-slate-700">{fmt(v.emballages, 3)}</td>
                    <td className="tabular px-3 py-2 font-data text-sm font-semibold text-slate-900">{fmt(v.total, 3)}</td>
                    <td className="px-3 py-2">
                      <span
                        data-testid={`reglement-${v.id}`}
                        className={`font-data text-[10px] uppercase tracking-[0.08em] px-1.5 py-0.5 ${
                          v.paiement === 'Différé' ? 'bg-amber-50 text-amber-800' : 'bg-emerald-50 text-emerald-800'
                        }`}
                      >
                        {v.paiement === 'Différé' ? 'créance client' : 'encaissé'}
                      </span>
                    </td>
                    <td className="px-3 py-2 font-data text-xs text-slate-600">{v.cuveNom}</td>
                    <td className="px-3 py-2 text-right">
                      <button
                        type="button"
                        data-testid={`imprimer-vente-${v.id}`}
                        onClick={() => setBl(v)}
                        className="inline-flex items-center gap-1.5 border border-slate-300 px-2 py-1 text-xs font-semibold text-slate-700 transition-colors duration-150 hover:bg-slate-900 hover:text-white"
                      >
                        <Printer size={13} /> PDF
                      </button>
                      {v.qrTracabiliteUrl && <a title="Certificat de traçabilité PDF" className="border px-2 py-1 text-xs" href={`${process.env.REACT_APP_BACKEND_URL}/api/portail/${encodeURIComponent(v.qrTracabiliteUrl.split('/').pop())}/certificat.pdf`} target="_blank" rel="noreferrer">Certificat PDF</a>}
                      <button
                        type="button"
                        data-testid={`ligne-libre-${v.id}`}
                        onClick={() => setLigneLibre({ venteId: v.id, designation: '', quantite: '1', unite: 'forfait', prixUnitaire: '' })}
                        className="ml-1.5 inline-flex items-center gap-1.5 border border-slate-300 px-2 py-1 text-xs font-semibold text-slate-700 transition-colors duration-150 hover:bg-slate-900 hover:text-white"
                        title="Ajouter une ligne libre (transport, prestation…)"
                      >
                        <Plus size={13} /> Ligne
                      </button>
                      <ActionsAdmin
                        id={v.id}
                        row={v}
                        titre="Corriger la vente"
                        champs={[
                          { key: 'date', label: 'Date', type: 'date' },
                          { key: 'client', label: 'Client' },
                          { key: 'prixKg', label: 'Prix vrac (TND/kg)', type: 'number' },
                          { key: 'prixUnitaire', label: 'Prix de vente unitaire (TND/u)', type: 'number' },
                          { key: 'denomination', label: 'Dénomination', options: DENOMINATIONS_HUILE },
                        ]}
                        onModifier={(patch) => adminModifierVente(v.id, patch, user?.name)}
                        onSupprimer={() => adminSupprimerVente(v.id, user?.name)}
                        onDone={load}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>

      {nouveauClient && (
        <ContactQuickForm
          typeInitial="tiers"
          onClose={() => setNouveauClient(false)}
          onCreated={(c) => {
            fetchTiers().then(setClients);
            setF((p) => ({ ...p, tiersId: c.id }));
            setNouveauClient(false);
          }}
        />
      )}

      {factureDiverse && (
        <FactureLibreDialog
          onClose={() => setFactureDiverse(false)}
          onCreated={() => {
            setFactureDiverse(false);
            load();
          }}
        />
      )}

      {ligneLibre && (
        <div data-testid="ligne-libre-overlay" className="fixed inset-0 z-[65] flex items-center justify-center bg-slate-900/60 p-4">
          <div className="w-full max-w-lg border border-slate-200 bg-white p-5">
            <h2 className="font-heading text-lg font-black tracking-tight text-slate-900">
              Ligne libre sur la facture {ligneLibre.venteId}
            </h2>
            <p className="mt-1 text-sm text-slate-600">
              Le montant s'ajoute au total de la facture et au solde dû du client.
            </p>
            <div className="mt-4 space-y-3">
              <input
                data-testid="ll-designation"
                placeholder="Désignation (ex. Frais de transport)"
                value={ligneLibre.designation}
                onChange={(e) => setLigneLibre({ ...ligneLibre, designation: e.target.value })}
                className="h-11 w-full border border-slate-300 bg-slate-50 px-3 text-sm outline-none focus:border-slate-900 focus:bg-white"
              />
              <div className="flex gap-2">
                <input
                  data-testid="ll-quantite"
                  type="number"
                  step="0.001"
                  min="0"
                  placeholder="Qté"
                  value={ligneLibre.quantite}
                  onChange={(e) => setLigneLibre({ ...ligneLibre, quantite: e.target.value })}
                  className="h-11 w-24 border border-slate-300 bg-slate-50 px-2 text-center font-data text-sm outline-none focus:border-slate-900"
                />
                <select
                  data-testid="ll-unite"
                  value={ligneLibre.unite}
                  onChange={(e) => setLigneLibre({ ...ligneLibre, unite: e.target.value })}
                  className="h-11 w-32 border border-slate-300 bg-slate-50 px-2 font-data text-sm outline-none focus:border-slate-900"
                >
                  {UNITES_LIGNE.map((u) => (
                    <option key={u} value={u}>{u}</option>
                  ))}
                </select>
                <input
                  data-testid="ll-prix"
                  type="number"
                  step="0.001"
                  min="0"
                  placeholder="Prix unitaire"
                  value={ligneLibre.prixUnitaire}
                  onChange={(e) => setLigneLibre({ ...ligneLibre, prixUnitaire: e.target.value })}
                  className="h-11 flex-1 border border-slate-300 bg-slate-50 px-2 text-center font-data text-sm outline-none focus:border-slate-900"
                />
              </div>
            </div>
            <div className="mt-5 flex gap-3">
              <button
                type="button"
                data-testid="ll-ajouter"
                onClick={async () => {
                  const { error, row } = await ajouterLigneLibreVente(ligneLibre.venteId, ligneLibre);
                  if (error) return toast.error(error);
                  toast.success(`Ligne ajoutée — nouveau total ${fmt(row.total, 3)} TND`);
                  setLigneLibre(null);
                  load();
                }}
                className="h-11 flex-1 bg-slate-900 font-heading text-sm font-bold uppercase tracking-[0.08em] text-white transition-colors duration-150 hover:bg-slate-700"
              >
                Ajouter à la facture
              </button>
              <button
                type="button"
                data-testid="ll-annuler"
                onClick={() => setLigneLibre(null)}
                className="h-11 border border-slate-300 px-5 text-sm font-semibold text-slate-700 hover:bg-slate-100"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}

      {bl && (
        <PrintDoc
          qrUrl={urlTrace(bl)}
          qrLegende="Origines, variétés et certificat de traçabilité"
          type="Bon de livraison / Ticket de vente"
          numero={bl.piece ?? bl.id}
          emission={{
            type: 'vente',
            id: bl.id,
            libelle: 'Vente d’huile d’olive',
            date: bl.date,
            tiersId: bl.tiersId,
            tiers: bl.client,
            referenceInterne: bl.piece ?? bl.id,
            total: bl.total,
            mentions: bl.paiement === 'Différé' ? 'Facture à régler — montant porté au solde dû du client.' : 'Encaissé au comptant.',
            lignes: [
              ['Désignation', bl.denomination ?? 'Huile d’olive'],
              ['Format de vente', nomFormat(bl.format, bl)],
              ['Poids livré', `${fmt(bl.kg, 3)} kg`],
              ['Origine', bl.cuveNom],
            ],
            totaux: [['Total à payer', `${fmt(bl.total, 3)} TND`]],
          }}
          date={bl.date}
          tiers={bl.client}
          lignes={[
            ['Désignation', bl.denomination ?? 'Huile d’olive'],
            ['Format de vente', nomFormat(bl.format, bl)],
            ...(bl.format === 'vrac'
              ? []
              : [
                  ['Unités', bl.unites ? fmt(bl.unites) : '—'],
                  ['Volume', `${fmt(bl.litres, 3)} L`],
                  ['Conversion appliquée', `1 L = ${DENSITE_HUILE} kg`],
                ]),
            ...(bl.format === 'vrac'
              ? []
              : [['Prix de vente unitaire', `${fmt(bl.prixUnitaire ?? 0, 3)} TND / unité`]]),
            ['Poids livré', `${fmt(bl.kg, 3)} kg`],
            ['Origine', bl.cuveNom],
            ['Règlement', bl.paiement === 'Différé' ? 'Paiement différé — créance portée au compte client' : 'Encaissé au comptant'],
          ]}
          totaux={[
            ...(bl.format === 'vrac'
              ? [['Huile', `${fmt(bl.kg * bl.prixKg, 3)} TND`], ['Emballages', `${fmt(bl.emballages, 3)} TND`]]
              : [['Produits finis', `${fmt(bl.unites * (bl.prixUnitaire ?? 0), 3)} TND`]]),
            ...(bl.lignesLibres ?? []).map((l) => [l.designation, `${fmt(l.total, 3)} TND`]),
            ['Total à payer', `${fmt(bl.total, 3)} TND`],
          ]}
          mentions={`${
            bl.format === 'vrac'
              ? `Prix unitaire huile : ${fmt(bl.prixKg, 3)} TND/kg.`
              : `Prix de vente : ${fmt(bl.prixUnitaire ?? 0, 3)} TND l’unité.`
          }${
            bl.paiement === 'Différé' ? ' Facture à régler — montant porté au solde dû du client.' : ''
          }`}
          onClose={() => setBl(null)}
        />
      )}
    </div>
  );
}
